import type { CommerceTranslation } from './types';

/** Urdu. Pending review by native speakers. */
export const commerceUr: CommerceTranslation = {
  nav: { orders: 'آرڈرز', finance: 'مالی استثنائی معاملات' },
  orders: {
    title: 'آرڈرز',
    description:
      'چیٹ میں دیے گئے آرڈرز۔ ادائیگی اور رقم کی واپسی کی صورتحال ادائیگی فراہم کنندہ سے آتی ہے، چیٹ سے نہیں۔',
    search: 'آرڈر نمبر سے تلاش کریں',
    needsAttention: 'صرف وہ آرڈرز جن پر توجہ درکار ہے',
    empty: 'ابھی کوئی آرڈر نہیں۔',
    emptyFiltered: 'کوئی آرڈر مطابقت نہیں رکھتا۔',
    clearFilters: 'تمام آرڈرز دکھائیں',
    loading: 'آرڈرز لوڈ ہو رہے ہیں',
    columns: {
      reference: 'آرڈر',
      customer: 'گاہک',
      placed: 'دیا گیا',
      total: 'کل',
      payment: 'ادائیگی',
      fulfilment: 'تکمیل',
      attention: 'توجہ درکار',
    },
    visitor: 'وزیٹر',
    pendingRefunds_one: '{{count}} رقم کی واپسی فیصلے کی منتظر',
    pendingRefunds_other: '{{count}} رقوم کی واپسی فیصلے کی منتظر',
    openExceptions_one: '{{count}} استثنائی معاملہ',
    openExceptions_other: '{{count}} استثنائی معاملات',
  },
  payment: {
    not_started: 'ادائیگی نہیں ہوئی',
    requires_action: 'گاہک کا انتظار',
    processing: 'تصدیق ہو رہی ہے',
    authorized: 'مجاز',
    captured: 'ادا شدہ',
    failed: 'ناکام',
    cancelled: 'منسوخ',
    unknown: 'تصدیق نہیں ہوئی',
  },
  orderState: {
    draft: 'مسودہ',
    submitted: 'ادائیگی کا انتظار',
    confirmed: 'تصدیق شدہ',
    partially_fulfilled: 'جزوی طور پر مکمل',
    fulfilled: 'مکمل',
    cancel_requested: 'منسوخی کی درخواست',
    cancelled: 'منسوخ',
    returned: 'واپس',
  },
  fulfilment: {
    not_started: 'شروع نہیں ہوا',
    pending: 'باقی',
    in_progress: 'جاری',
    delayed: 'تاخیر',
    shipped: 'بھیج دیا گیا',
    delivered: 'پہنچ گیا',
    provisioned: 'فعال',
    failed: 'ناکام',
    cancelled: 'منسوخ',
  },
  detail: {
    loading: 'آرڈر لوڈ ہو رہا ہے',
    back: 'تمام آرڈرز',
    title: 'آرڈر {{reference}}',
    observed: '{{time}} پر ریکارڈ سے پڑھا گیا۔',
    seller: 'فروخت کنندہ',
    customer: 'گاہک',
    items: 'اشیاء',
    delivery: 'ڈیلیوری',
    total: 'کل',
    payment: 'ادائیگی',
    paidAt: 'ادائیگی کا وقت',
    providerRef: 'فراہم کنندہ کا حوالہ',
    paid: 'ادا شدہ',
    refunded: 'واپس کی گئی رقم',
    refundable: 'ابھی واپس کی جا سکتی ہے',
    fulfilments: 'تکمیل',
    noFulfilment: 'ابھی تکمیل کی کوئی اپ ڈیٹ نہیں۔',
    estimate: 'دکان کا اندازہ: {{date}}',
    kind: { shipment: 'شپمنٹ', service: 'سروس' },
    source: { merchant: 'دکان کے سسٹم سے', staff: 'ٹیم نے درج کیا' },
    tracking: 'ٹریکنگ نمبر: {{ref}}',
    updated: '{{time}} کو اپ ڈیٹ ہوا',
    operations: 'فراہم کنندہ کو بھیجی گئی درخواستیں',
    operationsDescription:
      'ادائیگی فراہم کنندہ کو بھیجی گئی ہر درخواست، اور کیا، کہاں سے اور کب دیکھا گیا۔',
    operationState: {
      pending: 'نہیں بھیجی گئی',
      dispatched: 'بھیجی گئی',
      succeeded: 'ہو گیا',
      failed: 'ناکام',
      unknown: 'نتیجہ ابھی معلوم نہیں',
      cancelled: 'منسوخ',
    },
    receipt: '{{kind}} · {{outcome}} · {{source}} · {{time}}',
    exceptions: 'استثنائی معاملات',
  },
  fulfilmentForm: {
    open: 'اپ ڈیٹ درج کریں',
    title: 'ڈیلیوری کا اپ ڈیٹ درج کریں',
    description: 'دکان نے جو بتایا وہ درج کریں۔ گاہک کو نئی صورتحال چیٹ میں نظر آئے گی۔',
    kind: 'کیا پورا کیا جا رہا ہے',
    state: 'نئی صورتحال',
    estimate: 'متوقع تاریخ',
    estimateHint:
      'صرف وہ تاریخ جو دکان نے دی ہو۔ گاہک اسے اندازے کے طور پر دیکھے گا، وعدے کے طور پر نہیں۔',
    carrierRef: 'ٹریکنگ نمبر',
    note: 'ٹیم کے لیے نوٹ',
    noteHint: 'گاہک یہ نوٹ نہیں دیکھتا۔',
    submit: 'محفوظ کریں اور گاہک کو بتائیں',
    saved: 'اپ ڈیٹ محفوظ ہو گیا۔ گاہک اسے چیٹ میں دیکھے گا۔',
  },
  refunds: {
    title: 'رقم کی واپسی',
    none: 'ابھی رقم کی کوئی واپسی نہیں۔',
    request: 'رقم کی واپسی کی درخواست کریں',
    requestDescription: '{{amount}} تک واپس کی جا سکتی ہے۔',
    policyAlways: 'ہر واپسی کے لیے کسی دوسرے فرد کی منظوری درکار ہے۔',
    policyThreshold: '{{amount}} سے زیادہ کی واپسی کے لیے کسی دوسرے فرد کی منظوری درکار ہے۔',
    amount: '{{currency}} میں رقم',
    fullOnly: 'یہ دکان صرف پوری رقم واپس کر سکتی ہے: {{amount}}۔',
    amountHint: 'مثلاً 35.00',
    ambiguous: 'آپ کی مراد کون سی رقم ہے؟',
    invalid: {
      empty: 'رقم درج کریں۔',
      format: '35.00 جیسی رقم درج کریں۔',
      precision: '{{currency}} کے لیے اعشاریہ کے بعد بہت زیادہ ہندسے ہیں۔',
      negative: 'صفر سے زیادہ رقم درج کریں۔',
      too_large: 'یہ رقم بہت بڑی ہے۔',
      over: 'یہ واپس کی جا سکنے والی رقم سے زیادہ ہے۔',
    },
    reason: 'وجہ',
    reasons: {
      customer_request: 'گاہک نے کہا',
      damaged: 'خراب نکلا',
      not_delivered: 'نہیں پہنچا',
      duplicate: 'دو بار رقم کٹی',
      other: 'دیگر',
    },
    note: 'ٹیم کے لیے نوٹ',
    submit: 'واپسی کی درخواست کریں',
    state: {
      requested: 'درخواست کی گئی',
      policy_checked: 'جانچا گیا',
      awaiting_approval: 'منظوری کا انتظار',
      submitted: 'فراہم کنندہ کو بھیجی گئی',
      pending: 'فراہم کنندہ کے پاس زیر کارروائی',
      succeeded: 'رقم واپس ہو گئی',
      rejected: 'مسترد',
      failed: 'ناکام',
      unknown: 'نتیجہ تصدیق شدہ نہیں',
    },
    requestedBy: '{{name}} نے کہا، {{time}}',
    approvedBy: '{{name}} نے منظور کیا، {{time}}',
    rejectedBy: '{{name}} نے مسترد کیا: {{reason}}',
    failureReason: 'فراہم کنندہ نے کہا: {{reason}}',
    approve: 'واپسی منظور کریں',
    reject: 'مسترد کریں',
    check: 'واپسی کی صورتحال دیکھیں',
    approveTitle: '{{amount}} کی واپسی منظور کریں؟',
    approveBody:
      'رقم ادائیگی فراہم کنندہ کے ذریعے گاہک کے ادائیگی کے طریقے میں واپس جاتی ہے۔ اسے یہاں سے واپس نہیں لیا جا سکتا۔',
    approveConfirm: 'منظور کریں اور بھیجیں',
    rejectTitle: 'یہ واپسی مسترد کریں؟',
    rejectReason: 'کیوں؟ (ٹیم اسے دیکھتی ہے)',
    rejectConfirm: 'واپسی مسترد کریں',
    samePerson: 'یہ واپسی آپ نے مانگی ہے، اس لیے کوئی اور اسے منظور کرے۔',
    noPermission: 'اس کا فیصلہ صرف وہ لوگ کر سکتے ہیں جو واپسی منظور کر سکتے ہیں۔',
    separateApprover: 'اس واپسی کو مانگنے والے کے علاوہ کوئی اور منظور کرے۔',
    pendingNote: 'فراہم کنندہ کی تصدیق تک اسے واپس شدہ نہیں مانا جاتا۔',
  },
  finance: {
    title: 'مالی استثنائی معاملات',
    description:
      'ایسی ادائیگیاں اور واپسیاں جن کا نتیجہ کسی فرد کو دیکھنا ہے۔ جانچنے سے فراہم کنندہ سے دوبارہ پوچھا جاتا ہے۔ حل کرنے سے آپ کا فیصلہ درج ہوتا ہے، کوئی رقم منتقل نہیں ہوتی۔',
    open: 'کھلے',
    resolved: 'حل شدہ',
    tabs: 'دکھائیں',
    empty: 'کسی چیز پر توجہ کی ضرورت نہیں۔',
    emptyResolved: 'ابھی کوئی حل شدہ معاملہ نہیں۔',
    loading: 'معاملات لوڈ ہو رہے ہیں',
    kind: {
      payment_unknown: 'ادائیگی کا نتیجہ معلوم نہیں',
      refund_unknown: 'واپسی کا نتیجہ معلوم نہیں',
      order_update_pending: 'ادائیگی ہو گئی، مگر آرڈر اپ ڈیٹ نہیں ہوا',
      amount_mismatch: 'رقم مختلف ہے',
      reconcile_exhausted: 'فراہم کنندہ جواب نہیں دے رہا',
      refund_failed: 'واپسی ناکام',
      provisioning_failed: 'سروس فعال نہیں ہوئی',
    },
    action: {
      check_status: 'صورتحال جانچیں',
      wait_for_provider: 'فراہم کنندہ کا انتظار کریں',
      contact_provider: 'فراہم کنندہ سے رابطہ کریں',
      review_order: 'آرڈر دیکھیں',
      retry_refund: 'جانچیں، پھر ضرورت ہو تو دوبارہ واپسی کریں',
    },
    nextAction: 'اگلا محفوظ قدم: {{action}}',
    providerState: 'فراہم کنندہ کی صورتحال: {{state}}',
    openedAt: '{{time}} سے کھلا',
    evidence: 'شواہد',
    order: 'آرڈر {{reference}}',
    check: 'فراہم کنندہ سے جانچیں',
    resolve: 'حل کریں',
    resolveTitle: 'یہ معاملہ حل کریں',
    resolution: 'حل',
    resolutions: {
      provider_confirmed: 'فراہم کنندہ نے نتیجے کی تصدیق کی',
      manual_review: 'ہاتھ سے جانچا گیا',
      refunded_elsewhere: 'کسی اور طریقے سے رقم واپس ہوئی',
      written_off: 'بٹے کھاتے میں ڈالا گیا',
    },
    note: 'آپ نے کیا جانچا',
    resolveConfirm: 'معاملہ حل کریں',
    resolvedAs: 'حل: {{resolution}}',
  },
};
